import React, { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  onAuthStateChanged,
  signOut
} from "firebase/auth";
import { auth } from "./firebase";
import Home from "./Home";

export default function App() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [user, setUser] = useState(null);

  // 🔥 Mantiene sesión activa
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      setUser(userCredential.user);
      setMessage("Login exitoso 🚀");
    } catch (e) {
      setMessage(e.message);
    }
  };

  const handleRegister = async () => {
    if (password !== confirmPassword) {
      setMessage("Las contraseñas no coinciden");
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      setUser(userCredential.user);
      setMessage("Cuenta creada 🔥");
    } catch (e) {
      setMessage(e.message);
    }
  };

  const handleReset = async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Email de recuperación enviado 📩");
    } catch (e) {
      setMessage(e.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
  };

  // 🔥 SI está logueado → HOME
  if (user) {
    return <Home user={user} onLogout={handleLogout} />;
  }

  // 🔐 LOGIN / REGISTER / FORGOT
  return (
    <div style={styles.container}>
      <div style={styles.card}>

        <img src="/logo.svg" alt="logo" style={styles.logo} />

        <h2 style={styles.title}>WhatBlue</h2>
        <p style={styles.subtitle}>Tu GPS mental</p>

        <input
          style={{ ...styles.input, boxSizing: "border-box", paddingRight: 40 }}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {mode !== "forgot" && (
          <div style={{ position: "relative" }}>
            <input
              style={{ ...styles.input, paddingRight: 40, boxSizing: "border-box" }}
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              style={styles.eyeButton}
              tabIndex={-1}
              aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4FC3F7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <ellipse cx="12" cy="12" rx="9" ry="6" />
                <circle cx="12" cy="12" r="2.5" fill={showPassword ? "#4FC3F7" : "none"} />
                {showPassword ? null : (
                  <line x1="4" y1="20" x2="20" y2="4" stroke="#4FC3F7" strokeWidth="2" />
                )}
              </svg>
            </button>
          </div>
        )}

        {/* Input de confirmación de contraseña solo en registro */}
        {mode === "register" && (
          <div style={{ position: "relative" }}>
            <input
              style={{ ...styles.input, paddingRight: 40, boxSizing: "border-box", border: confirmPassword && password !== confirmPassword ? "2px solid #ff5252" : undefined }}
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword((v) => !v)}
              style={styles.eyeButton}
              tabIndex={-1}
              aria-label={showConfirmPassword ? "Ocultar confirmación" : "Mostrar confirmación"}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4FC3F7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <ellipse cx="12" cy="12" rx="9" ry="6" />
                <circle cx="12" cy="12" r="2.5" fill={showConfirmPassword ? "#4FC3F7" : "none"} />
                {showConfirmPassword ? null : (
                  <line x1="4" y1="20" x2="20" y2="4" stroke="#4FC3F7" strokeWidth="2" />
                )}
              </svg>
            </button>
          </div>
        )}

        {mode === "login" && (
          <button style={styles.button} onClick={handleLogin}>
            Iniciar sesión
          </button>
        )}

        {mode === "register" && (
          <button style={styles.button} onClick={handleRegister}>
            Crear cuenta
          </button>
        )}

        {mode === "forgot" && (
          <button style={styles.button} onClick={handleReset}>
            Recuperar contraseña
          </button>
        )}

        <p style={styles.message}>{message}</p>

        <div style={styles.links}>
          {mode !== "login" && (
            <span onClick={() => setMode("login")}>Iniciar sesión</span>
          )}
          {mode !== "register" && (
            <span onClick={() => setMode("register")}>Crear cuenta</span>
          )}
          {mode !== "forgot" && (
            <span onClick={() => setMode("forgot")}>Olvidé contraseña</span>
          )}
        </div>

      </div>
    </div>
  );
}
const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #0A1F44, #000814)",
    fontFamily: "sans-serif",
  },
  card: {
    background: "rgba(255,255,255,0.05)",
    padding: "40px",
    borderRadius: "20px",
    backdropFilter: "blur(10px)",
    boxShadow: "0 0 40px rgba(0,150,255,0.2)",
    width: "320px",
    textAlign: "center",
  },
  logo: {
    width: "60px",
    marginBottom: "10px",
  },
  title: {
    color: "#4FC3F7",
    marginBottom: "5px",
  },
  subtitle: {
    color: "#aaa",
    marginBottom: "20px",
  },
  input: {
    width: "100%",
    padding: "12px",
    margin: "10px 0",
    borderRadius: "10px",
    border: "none",
    outline: "none",
    background: "rgba(255,255,255,0.1)",
    color: "#fff",
  },
  button: {
    width: "100%",
    padding: "12px",
    marginTop: "10px",
    borderRadius: "10px",
    border: "none",
    background: "#4FC3F7",
    color: "#000",
    fontWeight: "bold",
    cursor: "pointer",
  },
  message: {
    marginTop: "10px",
    color: "#ccc",
    fontSize: "13px",
  },
  links: {
    marginTop: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    color: "#4FC3F7",
    cursor: "pointer",
    fontSize: "14px",
  },
  eyeButton: {
    position: "absolute",
    top: "50%",
    right: 10,
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "18px",
  },
};